import React, {useMemo} from 'react';
import {Alert, Button} from '@mui/material';
import packageJson from '../../../package.json';
import {useVersion} from './useVersion';

const versionKey = 'savedVersion';

const VersionRefresh = () => {
  const version = useVersion();
  const doesVersionNeedUpdating = useMemo(() => {
    const savedVersion = window.sessionStorage.getItem(versionKey);
    // we only ask advisers to refresh once
    if (!version || version === savedVersion) {
      return false;
    }
    return packageJson?.version !== version;
  }, [version]);

  if (!doesVersionNeedUpdating) {
    return null;
  }

  const handleRefreshPage = () => {
    if (version) {
      window.sessionStorage.setItem(versionKey, version);
    }
    window.location.reload();
  };

  return (
    <Alert severity="warning" style={{display: 'flex', alignItems: 'center'}}>
      Please refresh the page to get the latest version.{' '}
      <Button variant="outlined" onClick={handleRefreshPage}>
        Refresh page
      </Button>
    </Alert>
  );
};

export default VersionRefresh;
